import { SUBSCRIPTION } from "../constants";
import { instance } from "../../axios";
import { store } from "../../store";

let removePatientSubscriptionAction = (id, body) => {
  return (dispatch) => {
    dispatch({
      type: SUBSCRIPTION.REMOVE_PATIENT_SUBSCRIPTION,
    });
    instance
      .post("/subscription/remove/" + id, body)
      .then((results) => {
        dispatch({
          type: SUBSCRIPTION.REMOVE_PATIENT_SUBSCRIPTION_SUCCESS,
          payload: results.data,
        });
        dispatch(getSubscriptionAction(id));
      })
      .catch((error) => {
        dispatch({
          type: SUBSCRIPTION.REMOVE_PATIENT_SUBSCRIPTION_FAILURE,
          payload: error,
        });
      });
  };
};

let addPatientSubscriptionAction = (id, body) => {
  return (dispatch) => {
    dispatch({
      type: SUBSCRIPTION.ADD_PATIENT_SUBSCRIPTION,
    });
    instance
      .post("/subscription/add/" + id, body)
      .then((results) => {
        dispatch({
          type: SUBSCRIPTION.ADD_PATIENT_SUBSCRIPTION_SUCCESS,
          payload: results.data,
        });
        dispatch(getSubscriptionAction(id));
      })
      .catch((error) => {
        dispatch({
          type: SUBSCRIPTION.ADD_PATIENT_SUBSCRIPTION_FAILURE,
          payload: error,
        });
      });
  };
};

let getSubscriptionAction = (id) => {
  return (dispatch) => {
    dispatch({
      type: SUBSCRIPTION.GET_SUBSCRIPTION,
    });
    instance
      .get("/subscription/" + id)
      .then((results) => {
        dispatch({
          type: SUBSCRIPTION.GET_SUBSCRIPTION_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: SUBSCRIPTION.GET_SUBSCRIPTION_FAILURE,
          payload: error,
        });
      });
  };
};

let getSubscriptionsAction = () => {
  return (dispatch) => {
    dispatch({
      type: SUBSCRIPTION.GET_SUBSCRIPTIONS,
    });
    instance
      .get(
        `/subscription?limit=${store.getState().subscription.limit}&offset=${
          store.getState().subscription.offset
        }&query=${encodeURI(store.getState().subscription.query)}&typeFilter=${encodeURI(store.getState().subscription.typeFilter || "")}`
      )
      .then((results) => {
        dispatch({
          type: SUBSCRIPTION.GET_SUBSCRIPTIONS_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: SUBSCRIPTION.GET_SUBSCRIPTIONS_FAILURE,
          payload: error,
        });
      });
  };
};

let createSubscriptionAction = (body) => {
  return (dispatch) => {
    dispatch({
      type: SUBSCRIPTION.CREATE_SUBSCRIPTION,
    });
    instance
      .post("/subscription", body)
      .then((results) => {
        dispatch({
          type: SUBSCRIPTION.CREATE_SUBSCRIPTION_SUCCESS,
          payload: results.data,
        });
        dispatch(getSubscriptionsAction());
      })
      .catch((error) => {
        dispatch({
          type: SUBSCRIPTION.CREATE_SUBSCRIPTION_FAILURE,
          payload: error,
        });
      });
  };
};

let updateSubscriptionAction = (body) => {
  return (dispatch) => {
    dispatch({
      type: SUBSCRIPTION.UPDATE_SUBSCRIPTION,
    });
    return instance
      .post("/subscription/" + body.id, body)
      .then((results) => {
        dispatch({
          type: SUBSCRIPTION.UPDATE_SUBSCRIPTION_SUCCESS,
          payload: results.data,
        });
        dispatch(getSubscriptionsAction());
        return results;
      })
      .catch((error) => {
        dispatch({
          type: SUBSCRIPTION.UPDATE_SUBSCRIPTION_FAILURE,
          payload: error,
        });
        throw error;
      });
  };
};

let deleteSubscriptionAction = (id) => {
  return (dispatch) => {
    dispatch({
      type: SUBSCRIPTION.DELETE_SUBSCRIPTION,
    });
    instance
      .delete("/subscription/" + id)
      .then((results) => {
        dispatch({
          type: SUBSCRIPTION.DELETE_SUBSCRIPTION_SUCCESS,
          payload: results.data,
        });
        dispatch(getSubscriptionsAction());
      })
      .catch((error) => {
        dispatch({
          type: SUBSCRIPTION.DELETE_SUBSCRIPTION_FAILURE,
          payload: error,
        });
      });
  };
};

let setOffset = (offset) => {
  return (dispatch) => {
    dispatch({
      type: SUBSCRIPTION.SET_OFFSET,
      payload: offset,
    });
    dispatch(getSubscriptionsAction());
  };
};

let setQuery = (query) => {
  return (dispatch) => {
    dispatch({
      type: SUBSCRIPTION.SET_QUERY,
      payload: query,
    });
    dispatch(getSubscriptionsAction());
  };
};

let setTypeFilter = (typeFilter) => {
  return (dispatch) => {
    dispatch({
      type: SUBSCRIPTION.SET_TYPE_FILTER,
      payload: typeFilter,
    });
    dispatch(getSubscriptionsAction());
  };
};

let cleanSubscriptionAction = () => {
  return (dispatch) => {
    dispatch({
      type: SUBSCRIPTION.CLEAN_SUBSCRIPTION,
    });
  };
};

export {
  getSubscriptionsAction,
  getSubscriptionAction,
  setOffset,
  setQuery,
  setTypeFilter,
  cleanSubscriptionAction,
  createSubscriptionAction,
  updateSubscriptionAction,
  deleteSubscriptionAction,
  addPatientSubscriptionAction,
  removePatientSubscriptionAction,
};
